// extracted by mini-css-extract-plugin
module.exports = {"InfluencerDesks":"_1CDSxDDU","link":"_3oD9Gv-W","wrapper":"_2YKoR-_j","wrapperSpacing":"_28jHq5iP","placeholder":"lnnnOrZb"};